<template>
  <div class="radio-button-container">
    <label
      :for="optionAsString(option)"
      class="option-label"
      :class="{active: checkIfActive(option)}"
      v-for="(option, index) in options"
      :key="index"
    >
      <input
        type="radio"
        class="orientation-option"
        :name="optionAsString(option)"
        :id="optionAsString(option)"
        :value="option"
        v-model="selectedValue"
      />
      <span class="checkmark" :class="{ active: checkIfActive(option) }"></span>
      {{ optionAsString(option) }}
    </label>
  </div>
</template>
<script>
export default {
  name: "ProductRadioButtons",
  props: {
    options: Array,
    defaultVal: [String, Object],
    productType: String,
  },
  data() {
    return {
      selectedValue: this.defaultVal,
    };
  },
  watch: {
    selectedValue: function (newValue) {
      this.$emit("radio-value-changed", newValue);
    },
  },
  updated() {
    this.$emit("radio-updated");
  },
  methods: {
    // deriveDefaultOption() {
    //   if (typeof option !== "object") return this.defaultVal;
    // },
    checkIfActive(option) {
      if (typeof option !== "object") return option === this.selectedValue;
      let isActive = true;
      Object.keys(option).forEach((optionVal) => {
        if (
          !this.selectedValue[optionVal] ||
          this.selectedValue[optionVal] !== option[optionVal]
        ) {
          isActive = false;
        }
      });
      return isActive;
    },
    optionAsString(option) {
      if (typeof option !== "object") return option;
      if (this.productType === "Ottoman") {
        return option.width_1 + '" wide x ' + option.depth_size + '" deep';
      }
    },
  },
};
</script>
<style scoped>
.radio-button-container {
  display: grid;
  margin-top: 15px;
  gap: 6px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  /* flex-wrap: wrap;
  justify-content: center; */
}
input {
  display: none;
}
.checkmark {
  height: 14px;
  width: 14px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: relative;
  margin-right: 5px;
  flex-shrink: 0;
}
.checkmark::after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: 0.2s ease-in-out;
  background: #3a3830;
  content: "";
  position: absolute;
  opacity: 0;
}
.checkmark.active::after {
  opacity: 1;
}
label {
  padding: 12px 11px;
  flex-grow: 1;
  /* width: 100%; */
  cursor: pointer;
  display: flex;
  justify-content: left;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  /* max-width: 40%; */
}
label.active {
  background: #F0F0F0;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
/* @media screen and (min-width: 768px) {
  label {
    max-width: 43%;
  }
}
@media screen and (min-width: 1024px) {
  label {
    max-width: 40%;
  }
}
@media screen and (min-width: 1280px) {
  label {
    max-width: 43%;
  }
} */
</style>
